import { TPagination } from "@custom-types/sorting";
import { Gender } from "@enums/gender.enum";
import { PhoneNumber } from "@models/phone-number.model";

import { Account } from "./account.model";
import { AccountWithContraAccount } from "./account-with-contra-account.model";

export interface ClientModel {
  gfhAccounts: Account[];
  address: string | null;
  city: string;
  countryId: string;
  dateOfBirth: string; // ISO 8601
  dateOfDeath: string | null; // ISO 8601
  firstLetters: string;
  firstName: string | null;
  gender: Gender;
  homeNumber: number;
  homeNumberAddition: string | null;
  identificationNumber: string;
  identificationType: number;
  identificationValidUntil: string;
  incomeInNetherlands: boolean;
  lastName: string;
  lastNamePrefix: string | null;
  nationalityId: string;
  phoneNumbers: PhoneNumber[];
  relationNumber: string;
  socialSecurityNumber: string;
  street: string;
  taxInNetherlands: boolean;
  zipCode: string;
  accountManagerId: string | null;
  email: string;
  id: string;
  userName: string;
  utcInsertDate: string;
  utcUpdateDate: string;
  version: string;
  zipReg?: RegExp;
}

export class Client implements ClientModel {
  gfhAccounts: AccountWithContraAccount[] = [];
  address = "";
  city = "";
  countryId = "";
  dateOfBirth = "";
  dateOfDeath = null;
  firstLetters = "";
  firstName = null;
  gender = Gender.Male;
  homeNumber = 0;
  homeNumberAddition = "";
  identificationNumber = "";
  identificationType = 0;
  identificationValidUntil = "";
  incomeInNetherlands = false;
  lastName = "";
  lastNamePrefix = null;
  nationalityId = "";
  phoneNumbers: PhoneNumber[] = [];
  relationNumber = "";
  socialSecurityNumber = "";
  street = "";
  taxInNetherlands = false;
  zipCode = "";
  accountManagerId = null;
  email = "";
  id = "";
  userName = "";
  utcInsertDate = "";
  utcUpdateDate = "";
  version = "";
  zipReg?: RegExp;

  constructor(dto?: Client) {
    if (!dto) {
      return;
    }
    Object.assign(this, dto);
    if (dto?.phoneNumbers) {
      this.phoneNumbers = dto.phoneNumbers.map((p) => new PhoneNumber(p));
    }
    this.zipReg = /^[1-9][0-9]{3} ?(?!sa|sd|ss)[a-z]{2}$/i;
  }
}

export type TClientsPaginated = TPagination & {
  data: Array<Client>;
};
